<template>
    <div>
        <el-tabs v-model="activeName" type="card"  style="background-color: white">
            <el-tab-pane label="C# 示例" name="first">
                <mavon-editor
                        v-model="content"
                        ref="md"
                        @change="change"
                        class="deitor"
                        :toolbars="markdownOption"
                        :subfield="false"
                        defaultOpen="preview"
                />
            </el-tab-pane>
            <el-tab-pane label="Java 示例" name="second">
                <mavon-editor
                        v-model="content2"
                        ref="md"
                        @change="change"
                        class="deitor"
                        :toolbars="markdownOption"
                        :subfield="false"
                        defaultOpen="preview"
                />

            </el-tab-pane>
        </el-tabs></div>
</template>

<script>
    // 导入组件 及 组件样式

    import uploadimg from '../../components/UploadImg'
    import changeAddress from '../../components/Address'

    export default {
        name: "Add",
        components: {
            uploadimg,
            changeAddress,
        },

        data() {
            return {
                activeName: 'first',
                markdownOption:{

                    toolbarsBackground:'#ff2200',
                    editable:false,
                    subfield:false,
                },
                content2:"## 获取设备列表接口\n" +
                    "\n" +
                    "**简要描述：**\n" +
                    "\n" +
                    "- 获取设备列表\n" +
                    "\n" +
                    "**请求URL：**\n" +
                    "\n" +
                    "- `https://openapi.hzjly.cn/api/Monitor/GetDevList?devSN={devSN}`\n" +
                    "\n" +
                    "**请求方式：**\n" +
                    "\n" +
                    "- Get\n" +
                    "\n" +
                    "**请求参数：**\n" +
                    "\n" +
                    "| 参数名 | 必选 | 类型   | 说明       |\n" +
                    "| :----- | :--- | :----- | ---------- |\n" +
                    "| devSN  | 否   | string | 设备SN编号 |\n" +
                    "\n" +
                    "**响应参数：**\n" +
                    "\n" +
                    "| 参数 | 类型   | 描述                                           |\n" +
                    "| :--- | :----- | :--------------------------------------------- |\n" +
                    "| code | number | 101：身份验证异常 200：请求成功，500：接口异常 |\n" +
                    "| data | string | 数据json                                       |\n" +
                    "| msg  | string | 回参信息                                       |\n" +
                    "\n" +
                    "**备注**\n" +
                    "如果返回信息为：Authentication exception\n" +
                    "说明身份验证失败\n" +
                    "\n" +
                    "## 请求示例\n" +
                    "\n" +
                    "```\n" +
                    "public static String GetDateInfo()\n" +
                    "{\n" +
                    "    String devSN = \"190300495\";\n" +
                    "\n" +
                    "    String url = \"https://openapi.hzjly.cn/api/Monitor/GetDevList?devSN=\" + devSN + \"\";\n" +
                    "\n" +
                    "    //用户名以及密钥申请请联系管理员\n" +
                    "    String secret = \"93f115318cd68d7c0c6720352a72b022\";\n" +
                    "    String username = \"openApiTest\";\n" +
                    "\n" +
                    "    //获取GMT时间 详情请见获取GMT时间实例\n" +
                    "    String date = GetGMTTime();\n" +
                    "\n" +
                    "    //获取签名 详情请见签名获取方式\n" +
                    "    String signature = GetSignature(secret, username, date);\n" +
                    "\n" +
                    "    //身份验证信息拼接\n" +
                    "    String authorization = \"{\\\"UserName\\\":\\\"\" + username + \"\\\",\\\"Date\\\":\\\"\" + date + \"\\\",\\\"Signature\\\":\\\"\" + signature + \"\\\"}\";\n" +
            "\n" +
            "    //发送GET请求 详情请见GET请求实例\n" +
            "\n" +
            "    String result = CreateGetHttpResponse(url, authorization);\n" +
            "    return result;\n" +
            "\n" +
            "}\n" +
            "```\n" +
            "\n" +
            "## 返回示例\n" +
            "\n" +
            "```\n" +
            "{\n" +
            "   \"code\": 200,\n" +
            "   \"data\": [\n" +
            "       \"190300495\",\n" +
            "       \"190300498\",\n" +
            "       \"71111186\",\n" +
            "       \"190300495\"\n" +
            "   ],\n" +
            "   \"msg\": \"\"\n" +
            "}\n" +
            "```",
                content:"## 获取设备列表接口\n" +
                    "**简要描述：** \n" +
                    "\n" +
                    "- 获取设备列表\n" +
                    "\n" +
                    "**请求URL：** \n" +
                    "\n" +
                    "- `https://openapi.hzjly.cn/api/Monitor/GetDevList?devSN={devSN}`\n" +
                    "\n" +
                    "**请求方式：**\n" +
                    "- Get \n" +
                    "\n" +
                    "\n" +
                    "**请求参数：** \n" +
                    "\n" +
                    "|参数名|必选|类型|说明|\n" +
                    "|:----    |:---|:----- |-----   |\n" +
                    "| devSN| 否 | string | 设备SN编号 |\n" +
                    "\n" +
                    "**响应参数：** \n" +
                    "|参数|类型|描述|\n" +
                    "|:-------|:-------|:-------|\n" +
                    "| code| number| 101：身份验证异常 200：请求成功，500：接口异常|\n" +
                    "| data| string| 数据json |\n" +
                    "| msg|string | 回参信息 |\n" +
                    "\n" +
                    " **备注** \n" +
                    " 如果返回信息为：Authentication exception\n" +
                    "说明身份验证失败\n" +
                    "\n" +
                    "##  请求示例\n" +
                    "        public static string GetDevList()\n" +
                    "        {\n" +
                    "            string devSN = \"190300495\";\n" +
                    "\n" +
                    "            string url = \"https://openapi.hzjly.cn/api/Monitor/GetDevList?devSN=\" + devSN + \"\";\n" +
                    "\n" +
                    "           //用户名以及密钥申请请联系管理员\n" +
                    "            string secret = \"93f115318cd68d7c0c6720352a72b022\";\n" +
                    "            string username = \"openApiTest\";\n" +
                    "\n" +
                    "            //获取GMT时间 详情请见获取GMT时间实例\n" +
                    "            string date = GetGMTTime(DateTime.Now);\n" +
                    "\n" +
                    "            //获取签名 详情请见签名获取方式\n" +
                    "            string signature = GetSignature(secret, username, date);\n" +
                    "\n" +
                    "            //身份验证信息拼接\n" +
                    "            string authorization = \"{\\\"UserName\\\":\\\"\" + username + \"\\\",\\\"Date\\\":\\\"\" + date + \"\\\",\\\"Signature\\\":\\\"\" + signature + \"\\\"}\";\n" +
                    "\n" +
                    "            //发送GET请求 详情请见GET请求实例\n" +
                    "            string result = CreateGetHttpResponse(url, authorization);\n" +
                    "            return result;\n" +
                    "        }\n" +
                    "\n" +
                    "##  返回示例\n" +
                    "\n" +
                    " ``` \n" +
                    "{\n" +
                    "    \"code\": 200,\n" +
                    "    \"data\": [\n" +
                    "        \"190300495\",\n" +
                    "        \"190300498\",\n" +
                    "        \"71111186\",\n" +
                    "        \"190300495\"\n" +
                    "    ],\n" +
                    "    \"msg\": \"\"\n" +
                    "}\n" +
                    " ```\n" +
                    " \n" +
                    " \n" +
                    "----------", // 输入的markdown
                html:'',    // 及时转的html
            }
        },
        created() {
        },
        mounted() {

        },
        methods: {
            // 所有操作都会被解析重新渲染
            change(value, render){
                // render 为 markdown 解析后的结果[html]
                this.html = render;
            },
            // 提交
            submit(){
                console.log(this.content);
                console.log(this.html);
            }
        },

    };
</script>
<style scoped>
    @import "../../assets/css/normal.css";
.title-font{
    line-height: 40px;
    font-size: 16px;
    color: #4ba2f9;
    padding-right: 12px;
    width:248px;
    text-align: right;
    margin-left: 20px;
}

</style>
